import { render } from "./SubscribersOne.vue?vue&type=template&id=631af01e"
import script from "./SubscribersOne.vue?vue&type=script&lang=js"
export * from "./SubscribersOne.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/www-root/data/www/brazilist-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__